export const BASE = {
  name: 'recruit',
  path: '/microfrontend-prototype',
};
